import EntityLayout from '../../layouts/EntityLayout/EntityLayout';

import PerfilEdit from './routes/PerfilEdit';

export default (store) => ({
  path: 'perfil',
  childRoutes: [ // Ver https://github.com/davezuko/react-redux-starter-kit/issues/1070
    PerfilEdit(store),
  ],
  component: EntityLayout,
  indexRoute: { /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      /*  Webpack - use 'require.ensure' to create a split point
            and embed an async module loader (jsonp) when bundling   */
      require.ensure([], (require) => {
        /*  Webpack - use require callback to define
              dependencies for bundling   */
        const Perfil = require('./containers/PerfilContainer').default;

        /*  Add the reducer to the store on key 'counter'  */

        /*  Return getComponent   */
        cb(null, Perfil);

        /* Webpack named bundle   */
      }, 'perfil');
    },
  },
});



// WEBPACK FOOTER //
// ./src/routes/Perfil/index.js